import styled from "styled-components";

export const FormSelect = styled.div`
  height: 75px;
`;
